import { EventBus } from '../../plugins/eventBus';

const state = {
  io: {},
  socket_enabled: false,
  enabledSocketSettlementOddLive: false,
  shiftOutcomeAlreadyDefined: false
};

const getters = {
  getSocketEnabled: state => {
    return state.socket_enabled;
  },

  getEnabledSocketSettlementOddLive: state => {
    return state.enabledSocketSettlementOddLive;
  },

  getShiftOutcomeAlreadyDefined: state => {
    return state.shiftOutcomeAlreadyDefined;
  }
};

const actions = {
  socket_login: async (context, data) => {
    const params = {
      room: data.platform_id
    };
    context.rootState.socket.io.emit('join', params, () => {
      console.log(`Platform join this channel ${data.platform_id}`);
      context.commit('SET_SOCKET_ENABLED', true);
      console.log('SOCKET SOCKET_LOGIN', data);
    });
  },

  socket_login_generic: async (context, room) => {
    const params = {
      room: room
    };
    context.rootState.socket.io.emit('join', params, () => {
      console.log(`Platform join this channel ${room}`);
      context.commit('SET_SOCKET_ENABLED', true);
      console.log('SOCKET SOCKET_LOGIN_GENERIC', room);
    });
  },

  socket_enabled: async (context, data) => {
    console.log('SOCKET SOCKET_ENABLED', data);
    context.commit('SET_SOCKET_ENABLED', true);
  },

  socket_close: async (context, data) => {
    console.log('SOCKET SOCKET_CLOSE', data);
    context.rootState.socket.io.close('join', {}, () => {
      // console.log(`Platform join this channel ${data.platform_id}`)
      // context.commit('SET_SOCKET_ENABLED', true)
    });

    context.commit('SET_SOCKET_ENABLED', false);
  },
  SOCKET_NEW_EVENT_LIVE: async (context, data) => {
    console.log('SOCKET SOCKET_NEW_EVENT_LIVE', data);
    if (context.state.socket_enabled) {
      context.dispatch('odds/updateLiveCount', data, { root: true });
    }
  },
  // SOCKET_FIXTURE_CHANGE_LIVE: async (context, data) => {
  //     if (context.state.socket_enabled) {
  //
  //         context.dispatch('odds/updateFixureChangeCashout', data, {root: true})
  //         /*0: "FIXTURE_CHANGE_LIVE"
  //         1: {id: 4913114161, updated: "2022-01-02T18:40:42.764Z", sport_event_status: {_attributes: {status: 1}},…}
  //         FixtureExtraData: [{Name: "WithLivescore", Value: "true"}, {Name: "RotationNumbers", Value: "201930,201929"},…]
  //         0: {Name: "WithLivescore", Value: "true"}
  //         1: {Name: "RotationNumbers", Value: "201930,201929"}
  //         2: {Name: "WithInPlay", Value: "true"}
  //         3: {Name: "NumberOfPeriods", Value: "3"}
  //         id: 4913114161
  //         sport_event_status: {_attributes: {status: 1}}
  //         _attributes: {status: 1}
  //         status: 1
  //         updated: "2022-01-02T18:40:42.764Z"*/
  //     }
  // },
  SOCKET_ODDS_CHANGE_LIVE: async (context, data) => {
    console.log('SOCKET SOCKET_ODDS_CHANGE_LIVE', data);
    if (context.state.socket_enabled) {
      context.dispatch('odds/updateOddsLive', data, { root: true });
      context.dispatch('odds/updateLivescoreCashout', data, { root: true });
    }
  },

  SOCKET_SETTLEMENT_ODD_LIVE: async (context, data) => {
    console.log('SOCKET SOCKET_SETTLEMENT_ODD_LIVE', data);
    if (
      context.state.socket_enabled &&
      context.state.enabledSocketSettlementOddLive === true
    ) {
      context.dispatch('odds/disableAndOrderOddsDefined', data, { root: true });
    }
  },

  // SOCKET_SETTLEMENT_LIVE: async (context, data) => {
  //     if (context.state.socket_enabled) {
  //         context.dispatch('odds/settlementOddsLive', data, {root: true})
  //     }
  // },

  SOCKET_DEFINE_BET_LIST: async (context, data) => {
    if (context.state.socket_enabled) {
      context.dispatch('odds/settlementOddsLive', data, { root: true });
    }
  },
  SOCKET_LIVESCORE_LIVE: async (context, data) => {
    console.log(
      '[IllinoisSport Livescore] Socket SOCKET_LIVESCORE_LIVE ricevuto, socket_enabled:',
      context.state.socket_enabled
    );
    if (context.state.socket_enabled) {
      console.log(
        '[IllinoisSport Livescore] Socket - chiamando odds/updateLivescore'
      );
      context.dispatch('odds/updateLivescore', data, { root: true });
      // Aggiorna anche lo store IllinoisSport
      console.log(
        '[IllinoisSport Livescore] Socket - chiamando IllinoisSport/updateLiveEventLivescoreFromSocket'
      );
      context.dispatch(
        'IllinoisSport/updateLiveEventLivescoreFromSocket',
        data,
        { root: true }
      );
    } else {
      console.log(
        '[IllinoisSport Livescore] Socket - socket disabilitato, skip'
      );
    }
  },
  SET_SOCKET: async (context, payload) => {
    console.log('SOCKET SET_SOCKET', payload);
    context.commit('setSocket', payload);
  },

  SOCKET_PLACE_BET_CHANGED: async (context, payload) => {
    console.log('SOCKET SOCKET_PLACE_BET_CHANGED', payload);
    if (context.state.socket_enabled) {
      const parentBet = payload.parentBet;
      const status = payload.status;

      if (status == 'revived') {
        await context.dispatch(
          'cart/removeBetFromAcceptanceByCode',
          parentBet,
          { root: true }
        );

        const amount_real = payload.amount_real;
        let winning_total;

        /* todo api/socket need send the correct info , and i have not to do this in the UI */

        if (payload._multiple_detail.winning_total != null) {
          winning_total = payload._multiple_detail.winning_total;
        }

        if (payload._integral_detail.winning_total_max != null) {
          winning_total = payload._integral_detail.winning_total_max;
        }

        if (payload._system_detail.winning_all_total != null) {
          winning_total = payload._system_detail.winning_all_total;
        }

        const betInfo = {
          code: payload.code,
          parentBet: parentBet,
          amount_real: amount_real,
          winning_total: winning_total
        };
        await context.dispatch('cart/addAcceptBetWithChanges', betInfo, {
          root: true
        });
      }

      await context.dispatch('cart/placeBetChanged', payload, { root: true });
    }
  },

  SOCKET_RESERVE_BET_REJECT: async (context, payload) => {
    console.log('SOCKET SOCKET_RESERVE_BET_REJECT', payload);
    if (context.state.socket_enabled) {
      await context.dispatch('cart/removeBetFromAcceptance', payload, {
        root: true
      });
      await context.dispatch(
        'cart/removeBetFromAcceptedWithChange',
        payload.code,
        { root: true }
      );
      await context.dispatch('cart/addRejectedBet', payload, { root: true });
      EventBus.$emit('closeModalReserveAlert');
      EventBus.$emit('cleanTheCart');
    }
  },

  SOCKET_RESERVE_BET_ACCEPT: async (context, payload) => {
    if (context.state.socket_enabled) {
      await context.dispatch('cart/removeBetFromAcceptance', payload, {
        root: true
      });
      await context.dispatch('cart/addAcceptedBets', payload, { root: true });
      EventBus.$emit('closeModalReserveAlert');
      EventBus.$emit('cleanTheCart');
    }
  },

  setEnabledSocketSettlementOddLive: async (context, payload) => {
    context.commit('SET_ENABLED_SOCKET_SETTLEMENT_ODD_LIVE', payload);
  },

  setShiftOutcomeAlreadyDefined: async (context, payload) => {
    context.commit('SET_SHIFT_OUTCOME_ALREADY_DEFINED', payload);
  }
};

const mutations = {
  setSocket: (state, socket) => {
    state.io = socket;
  },

  SET_SOCKET_ENABLED(state, payload) {
    state.socket_enabled = payload;
  },

  SET_ENABLED_SOCKET_SETTLEMENT_ODD_LIVE(state, payload) {
    state.enabledSocketSettlementOddLive = payload;
  },

  SET_SHIFT_OUTCOME_ALREADY_DEFINED(state, payload) {
    state.shiftOutcomeAlreadyDefined = payload;
  }
};

const modules = {
  //  Message
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
  modules
};
